import ActoBoldWoff2 from '../../../assets/fonts/actoctt-bold-webfont.woff2'
import ActoBoldWoff from '../../../assets/fonts/actoctt-bold-webfont.woff'

import ActoMediumWoff2 from '../../../assets/fonts/actoctt-medium-webfont.woff2'
import ActoMediumWoff from '../../../assets/fonts/actoctt-medium-webfont.woff'

const cssBaseline = {
  MuiCssBaseline: {
    styleOverrides: `
      @font-face {
        font-family: 'ActoBold';
        font-style: normal;
        font-display: swap;
        font-weight: 700;
        src: local('Acto'), url(${ActoBoldWoff2}) format('woff2'), url(${ActoBoldWoff}) format('woff');
      }
      @font-face {
        font-family: 'ActoMedium';
        font-style: normal;
        font-display: swap;
        font-weight: 500;
        src: local('Acto'), url(${ActoMediumWoff2}) format('woff2'), url(${ActoMediumWoff}) format('woff');
      }
    `,
  },
}

export default cssBaseline
